/**
 * What's inside an item?
 *  - displayName - used for labels in the UI
 *  - key - for React lists (https://react.dev/learn/rendering-lists)
 *  - extractor - function to run on customer data to get the attr.
 */
const RULES = Object.freeze([
  {
    displayName: "Customer Name",
    key: "customer-name",
    extractor: (customerData) => customerData?.customerName,
  },
  {
    displayName: "Customer ID",
    key: "customer-id",
    extractor: (customerData) => customerData?.customerId,
  },
  {
    displayName: "Primary Admin",
    key: "primary-admin-lid",
    extractor: (customerData) => customerData?.primaryAdministrator?.loginId,
  },
]);

const extractBaseCustomerInfo = (customerData) => {
  const result = [];

  for (const rule of RULES) {
    try {
      const value = rule.extractor(customerData);
      result.push({
        displayName: rule.displayName,
        key: rule.key,
        value,
      });
    } catch (e) {
      if (e instanceof Error) {
        console.error(
          `Could not extract ${rule.key} from customer data: #${JSON.stringify(
            customerData
          )}#`,
          e
        );
      }
    }
  }

  return result;
};

export default extractBaseCustomerInfo;
